import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { fieldDefinitions, ruleDefinitions } from '../ReportFormFieldDefs';

const rules = {
    multipleEmails: ruleDefinitions.multipleEmails,
    requiredUnless: ruleDefinitions.requiredUnless,
    requiredIfEmptyArray: ruleDefinitions.requiredIfEmptyArray,
    requiredTagsForDepartmentManager:
        ruleDefinitions.requiredTagsForDepartmentManager,
};

const plugins = {
    dvr: dvr({
        package: validatorjs,
        extend: ({ validator, form }) => {
            // here we can access the `validatorjs` instance (validator)
            // and we can add the rules using the `register()` method.
            Object.keys(rules).forEach((key) =>
                validator.register(key, rules[key].function, rules[key].message)
            );
        },
    }),
};

const fields = {
    name: fieldDefinitions.name,
    employeeLists: fieldDefinitions.employeeLists,
    allEmployees: fieldDefinitions.allEmployees,
    recipientsEmails: fieldDefinitions.recipientsEmails,
    reportTags: fieldDefinitions.reportTags,
    customEmailSubject: fieldDefinitions.customEmailSubject,
    reportType: fieldDefinitions.reportType,
};

const options = {
    showErrorsOnReset: false,
};

class ReportSnapshotFormDef extends MobxReactForm {
    constructor(setup, hooks) {
        super({ fields, ...setup }, { plugins, hooks, options });
    }
}

export default ReportSnapshotFormDef;
